import Form from "./Form";
import useBeforeYouStart from "./hooks/useBeforeYouStart";

const BeforeYouStart = () => {
  const props = useBeforeYouStart();
  return <Form {...props} />;
};

export default BeforeYouStart;
